import { useState } from 'react';
import { Api } from './interface';
import ExcelUploader from './excelUploader.js';
import { toast } from 'react-toastify';
import { preprocessPOData } from './bulkUtil.js';

const REQUIRED_KEYS = [
  'Order',
  'IO Description',
  'Purchasing Document',
  'Document Date',
  'PO Title',
  'Order Quantity',
];

function ImportPODetails() {
  const [processing, setProcessing] = useState(null);
  const [uploadRes, setUploadRes] = useState(null);

  const uploadData = (data) => {
    setProcessing(true);

    try {
      // Use preprocessing pipeline from bulkUtil
      const processedData = preprocessPOData(data, {
        requiredKeys: REQUIRED_KEYS,
        dateField: 'Document Date',
        keyFields: ['Order', 'Purchasing Document', 'Short Text'],
        quantityField: 'Order Quantity',
        headerIdentifier: 'Order',
      });

      // Send processed data to API
      Api({
        sp: 'uploadPurchaseInfo',
        json: {
          list: processedData,
        },
      })
        .then((response) => {
          setProcessing(false);
          if (response) {
            setUploadRes(response);
            toast.success('File processed successfully!');
          } else {
            toast.error('Error processing your request');
          }
        })
        .catch((error) => {
          setProcessing(false);
          toast.error('API Error: ' + error.message);
        });
    } catch (error) {
      setProcessing(false);
      toast.error(error.message);
    }
  };

  const resetData = () => {
    setProcessing(null);
    setUploadRes(null);
  };

  return (
    <div>
      <h2>Purchase Order Upload</h2>
      <ExcelUploader
        processData={uploadData}
        isUploading={processing}
        response={uploadRes}
        resetData={resetData}
        templateHeaders={REQUIRED_KEYS}
        sheetName="PO Details"
        templateName="PO_Upload_Template"
      />
    </div>
  );
}

export default ImportPODetails;
